var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"networkError"},[_c('p',{staticStyle:{"font-weight":"bolder"}},[_vm._v("This code or link is no longer valid")]),_c('div',{staticClass:"tryingButton",on:{"click":_vm.backToMain}},[_vm._v("Ok")])])
}
var staticRenderFns = []

export { render, staticRenderFns }